<template>
  <div class="page">
    <div class="page__header" style="margin-bottom: 25px">
      <h1 style="margin-top: 10px">Content</h1>
      <div class="page__header-search">
        <BaseSelect
          class="form-control--grey form-control--xs"
          placeholder="Search by"
          :selected="searchType"
          :items="searchTypes"
          @input="serachingType"
        ></BaseSelect>
        <BaseInput
          class="form-control--grey form-control--xs"
          style="max-width: 65rem"
          placeholder="Search"
          :icon="true"
          :timeout="true"
          :element="tableData.search"
          @input="searchItems"
        >
          <template #icon>
            <IconSearch color="#000" height="16" width="16"></IconSearch>
          </template>
        </BaseInput>
      </div>
    </div>
    <div class="page__header">
      <HorisontalTabsList :tabs="tabs"></HorisontalTabsList>
      <div class="page__header_right">
        <FilterBlock
          :items="filters"
          @open="openFilters = $event"
          @selectFilter="selectFilter"
          @apply="refreshSelectedFilters"
          @clear="refreshSelectedFilters(true)"
        ></FilterBlock>
        <ViewToggle @input="viewType = $event"></ViewToggle>
        <IconButton
          class="button--admin button--auto button--outline-grey button--ml-15"
          text="add press release"
          @click="modal = true"
        >
          <IconPlusBold></IconPlusBold>
        </IconButton>
      </div>
    </div>
    <div class="page__filters">
      <template v-for="filter in selectedFilters"
        ><Tag
          class="tag--capitalize"
          v-for="i in filter.items"
          :key="i.title"
          :value="i.title"
          :close="true"
          :disabled="openFilters"
          @deleteTag="selectFilter({ key: filter.key, filter: i, apply: true })"
        ></Tag
      ></template>
    </div>
    <template v-if="viewType === 'list'">
      <Table
        :loading="loading"
        :items="items"
        :headerItems="headerItems"
        :tableData="tableData"
        :hasMorePages="hasMorePages"
        @sortTable="sortTable"
        @clickAction="clickAction"
        @loadMore="loadMore"
      ></Table>
    </template>
    <CardView
      class="cards--side-three"
      v-else
      :items="items"
      @clickAction="clickAction"
      :hasMorePages="hasMorePages"
      @loadMore="loadMore"
    ></CardView>
    <Pressrelease
      v-if="modal"
      :modal="modal"
      :item="item"
      @hideModal="modal = false"
      @createItem="createItem"
      @updateItem="updateItem"
      @removeItem="confirmRemoveItem"
      @updateTag="apiGetFiltersBlock(filterBlock)"
    ></Pressrelease>
  </div>
</template>
<script>
import BaseInput from "@/components/inputs/BaseInput.vue";
import IconSearch from "@/components/icons/IconSearch.vue";
import HorisontalTabsList from "@/components/HorisontalTabsList.vue";
import FilterBlock from "@/components/Filter.vue";
import ViewToggle from "@/components/ViewToggle.vue";
import Tag from "@/components/Tag.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import IconPlusBold from "@/components/icons/IconPlusBold.vue";
import Table from "@/components/Table.vue";
import CardView from "@/components/CardView.vue";
import Pressrelease from "./Pressrelease.vue";
import BaseSelect from "@/components/inputs/BaseSelect.vue";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  components: {
    BaseInput,
    IconSearch,
    HorisontalTabsList,
    FilterBlock,
    IconButton,
    IconPlusBold,
    Table,
    CardView,
    Tag,
    Pressrelease,
    ViewToggle,
    BaseSelect,
  },
  data() {
    return {
      tabs: [
        {
          title: "In The News",
          path: "/admin/content/in-the-news",
          key: "in-the-news",
        },
        {
          title: "Press Releases",
          path: "/admin/content/press-releases",
          key: "pressreleases",
        },
        {
          title: "Lives Well Lived",
          path: "/admin/content/lives-well-lived",
          key: "memoriams",
        },
        {
          title: "Loose Threads",
          path: "/admin/content/loose-threads",
          key: "loose-threads",
        },
        {
          title: "Tags",
          path: "/admin/content/tags",
          key: "tags",
        },
      ],
      viewType: "list",
      modal: false,
      filterBlock: {
        list: "statuses",
        type: "content",
      },
      openFilters: false,
      tableData: {
        page: 1,
        sort: "title",
        order: "asc",
        status: "",
        types: "",
        search: "",
        search_type: "",
      },
      searchTypes: [
        {
          id: "title",
          title: "Title",
        },
        {
          id: "author",
          title: "Author",
        },
        {
          id: "tags",
          title: "Tags",
        },
      ],
      searchType: "title",
    };
  },
  async created() {
    await this.apiGetFiltersBlock(this.filterBlock);
    await this.apiGetPressReleases(this.tableData);
    this.initialItem();
  },
  computed: {
    ...mapGetters("filters", {
      filters: "getFilters",
      selectedFilters: "getSelectedFilters",
    }),
    ...mapGetters("pressreleases", {
      items: "getItems",
      headerItems: "getItemsHeaders",
      item: "getItem",
      loading: "getLoading",
      hasMorePages: "getHasMorePages",
    }),
  },
  watch: {
    modal(val) {
      if (!val) {
        this.initialItem();
        this.setError(null);
      }
    },
  },
  methods: {
    ...mapActions("general", ["apiDeleteUploadImage"]),
    ...mapActions("filters", ["apiGetFiltersBlock"]),
    ...mapMutations("filters", ["updateFilters", "updateSelectedFilters", "clear"]),
    ...mapActions("pressreleases", [
      "apiGetPressReleases",
      "apiGetPressRelease",
      "apiPostPressRelease",
      "apiPutPressRelease",
      "apiDeletePressRelease",
    ]),
    ...mapMutations("pressreleases", ["initialItem", "setError"]),
    selectFilter(val) {
      this.updateFilters(val);
      if (val.apply) {
        this.refreshSelectedFilters();
      }
    },
    async sortTable({ sort, order }) {
      let data = { ...this.tableData, page: 1, sort, order };
      let success = await this.apiGetPressReleases(data);
      if (success) {
        this.tableData = data;
      }
    },
    async loadMore() {
      if (this.hasMorePages) {
        let data = { ...this.tableData, page: this.tableData.page + 1 };
        let success = await this.apiGetPressReleases(data);
        if (success) {
          this.tableData = data;
        }
      }
    },
    serachingType(value) {
      this.searchType = value.id;
      this.searchItems(this.tableData.search);
    },
    async searchItems(val) {
      if (this.tableData.search != val || this.tableData.search_type != this.searchType) {
        let data = { ...this.tableData, page: 1, search: val, search_type: this.searchType };
        let success = await this.apiGetPressReleases(data);
        if (success) {
          this.tableData = data;
        }
      }
    },
    async refreshSelectedFilters(clear) {
      if (clear) {
        await this.clear();
      }
      await this.updateSelectedFilters();
      this.filterTable();
    },
    async filterTable() {
      let data = { ...this.tableData, page: 1 };
      this.selectedFilters.forEach(el => {
        let filters = el.items.map(i => {
          return i.id;
        });
        data[el.key] = filters.join(",");
      });
      let success = await this.apiGetPressReleases(data);
      if (success) {
        this.tableData = data;
      }
    },
    async clickAction({ key, id, item }) {
      switch (key) {
        case "edit": {
          let result = await this.apiGetPressRelease(id);
          if (result) {
            this.modal = true;
          }
          break;
        }
        case "delete": {
          let result = await this.confirmRemoveItem(item);
          if (result) {
            this.modal = true;
          }
          break;
        }
        case "view": {
          if (item.status !== "draft")
            this.$router.push({ path: `/media/press-releases/${item.slug}` });
          break;
        }
      }
    },

    async createItem({ data, imageForRemove }) {
      let result = await this.apiPostPressRelease(data);
      if (result) {
        let data = { ...this.tableData, page: 1 };
        let success = await this.apiGetPressReleases(data);
        if (success) {
          this.tableData = data;
        }
        this.modal = false;
        /*if (imageForRemove.length) {
          this.apiDeleteUploadImage(imageForRemove);
        }*/
      }
    },
    async updateItem({ data, imageForRemove }) {
      let result = await this.apiPutPressRelease(data);
      if (result) {
        let data = { ...this.tableData, page: 1 };
        let success = await this.apiGetPressReleases(data);
        if (success) {
          this.tableData = data;
        }
        this.modal = false;
        /*if (imageForRemove.length) {
          this.apiDeleteUploadImage(imageForRemove);
        }*/
      }
    },
    confirmRemoveItem(item) {
      this.$swal({
        title: `Delete ${item.title}`,
        html: "<h5>Are you sure? <br/> This cannot be undone.",
        showCancelButton: true,
        showConfirmButton: false,
        showDenyButton: true,
        denyButtonText: "Delete",
        cancelButtonText: "Cancel",
      }).then(result => {
        if (result.value === false) {
          this.removeItem(item.id);
        }
      });
    },
    async removeItem(id) {
      let result = await this.apiDeletePressRelease(id);
      if (result) {
        let data = { ...this.tableData, page: 1 };
        let success = await this.apiGetPressReleases(data);
        if (success) {
          this.tableData = data;
        }
        this.modal = false;
      }
    },
  },
};
</script>
